import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/Header.tsx");
